(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ob-stage]').forEach((card) => {
      if (card.dataset.obReady) return;
      card.dataset.obReady = 'true';
      const fine = matchMedia('(hover: hover) and (pointer: fine)');
      const stage = card.querySelector('.ob-catalog-card__art');
      let start = null;
      let swiped = false;
      const setFace = (face) => {
        card.dataset.face = face;
        card.querySelectorAll('[data-ob-face]').forEach((control) => control.setAttribute('aria-pressed', String(control.dataset.obFace === face)));
      };
      stage.addEventListener('pointerenter', (event) => {
        if (fine.matches && event.pointerType === 'mouse' && card.classList.contains('has-back') && !card.dataset.manualFace) setFace('back');
      });
      stage.addEventListener('pointerleave', () => { if (!card.dataset.manualFace) setFace('front'); });
      stage.addEventListener('pointerdown', (event) => {
        swiped = false;
        start = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
      });
      stage.addEventListener('pointerup', (event) => {
        if (!start || !card.classList.contains('has-back')) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        swiped = true;
        card.dataset.manualFace = 'true';
        setFace(dx < 0 ? 'back' : 'front');
      });
      stage.addEventListener('pointercancel', () => { start = null; swiped = false; });
      stage.addEventListener('click', (event) => { if (swiped) { event.preventDefault(); swiped = false; } });
      stage.addEventListener('keydown', (event) => {
        if (!card.classList.contains('has-back') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        card.dataset.manualFace = 'true';
        setFace(event.key === 'ArrowRight' ? 'back' : 'front');
      });
      card.querySelectorAll('[data-ob-face]').forEach((button) => {
        button.addEventListener('click', () => {
          card.dataset.manualFace = 'true';
          setFace(button.dataset.obFace);
        });
      });
    });
    root.querySelectorAll('[data-ob-sort]').forEach((form) => {
      if (form.dataset.obReady) return;
      form.dataset.obReady = 'true';
      form.querySelector('select').addEventListener('change', () => form.requestSubmit());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
